<template>
  <div class="an-body">
    <FormItem :prop="prop" :rules="myRules">
      <div>
        <!-- {{ config.ifOpenGroup }} -->
        <!-- 如果是组 -->
        <template v-if="config.ifOpenGroup">
          <div v-for="(item, index) of config.optionGroupList" :key="index">
            <div class="group">
              <div v-if="showGroupTitle(item)" v-html="item.displayTitle" class="group-title"></div>
              <div v-if="item.imgUrl && showGroupTitle(item)" class="group-media">
                <ipsos-av v-if="isAv(item.imgUrl)" :src="item.imgUrl"></ipsos-av>
                <ipsos-image v-else :imgUrl="item.imgUrl" :preview="item.id"></ipsos-image>
              </div>
              <component
                ref="option"
                :config="config"
                :model="model"
                :optionValueKey="optionValueKey"
                :multiple="multiple"
                :groupId="item.id"
                :cvtLang="cvtLang"
                @selectItem="selectItem"
                :is="`answer-option-single-${windowType}`"
              ></component>
            </div>
          </div>
          <div>
            <component
              ref="option"
              :config="config"
              :model="model"
              :optionValueKey="optionValueKey"
              :multiple="multiple"
              :isOther="true"
              :cvtLang="cvtLang"
              @selectItem="selectItem"
              :is="`answer-option-single-${windowType}`"
            ></component>
          </div>
        </template>
        <template v-else>
          <component
            ref="option"
            :config="config"
            :model="model"
            :optionValueKey="optionValueKey"
            :multiple="multiple"
            :cvtLang="cvtLang"
            @selectItem="selectItem"
            :is="`answer-option-single-${windowType}`"
          ></component>
        </template>
      </div>
    </FormItem>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getVotingResult } from '@/service/survey'
export default {
  name: 'AnswerOptionList',
  props: [
    'config',
    'prop',
    'model',
    'optionKey',
    'optionValueKey',
    'multiple',
    'answerValidate',
    'crtDescIndex',
    'rules'
  ],
  data () {
    const { model, prop, answerValidate, config: { answerConfig: { requireInd } }, cvtLang, getSurveyInfoLang } = this
    return {
      otherSelected: false,
      myRules: [
        {
          validator: (rule, value, callback) => {
            let valIndex
            if (this.config.elementType === 'RateGroupBox') {
              // 矩阵滑块-利克特量表
              valIndex = Number(rule.field.split('.')[1])
            }
            let errors = []
            if (answerValidate) {
              errors = answerValidate.validate.bind(this.config)(this, true, valIndex).errors
            } else {
              if (requireInd === '1' && !model[prop]) {
                errors.push(cvtLang('tipAnswerNull', getSurveyInfoLang().tipAnswerNull))
              }
            }
            if (errors.length) {
              return callback(errors)
            }
            callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      answerStyleConfig: ({ Question }) => Question.answerStyleConfig,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      langMap: ({Question}) => Question.langMap
    })
  },
  methods: {
    isAv (url) {
      return url && url.includes('.mp4')
    },
    // 选项逻辑都不满足则不显示分组名称了
    showGroupTitle(data) {
      return this.config.optionList.filter(item => {
        return item.optionGroupId === data.id
      }).some(item => {
        return item.visibility === true || item.visibility === '1'
      })
    },
    isOtherSelected () {
      const { multiple, model, config } = this
      const value = model.value
      const otherList = config.optionList.filter(
        item => item.type === 'other'
      )
      if (multiple) {
        return value.some(item => {
          if (otherList.find(o => o.id === item)) {
            return true
          }
          return false
        })
      } else {
        return otherList.some(item => item.id === value)
      }
    },
    selectItem (option) {
      const { multiple, model, config } = this
      const { selectedValue, value } = this.getValue(option)
      const type = option.type

      // 显示投票结果时动态计算投票结果
      if (this.config.answerConfig.isShowVotingScore === '1') {
        this.config.optionList.forEach(optionItem=>{
          // 第一次做选择时，总样本量+1
          if (!this.model.value) {
            optionItem.sumVotes += 1
          }

          // 被选中时该选项的样本量+1
          if (optionItem.id === option.id) {
            optionItem.votes += 1
          }

          // 上一次选中的值-1
          if (optionItem.id === this.model.value) {
            optionItem.votes -= 1
          }

          // 计算占比
          if (optionItem.sumVotes) {
            optionItem.percentage = parseInt(optionItem.votes/optionItem.sumVotes * 100)
            optionItem.rate = Number(optionItem.votes/optionItem.sumVotes * 100).toFixed(2)
          }
        })
      }

      if (type === 'special') {
        if (multiple) {
          model.value = value.includes(selectedValue) ? [] : [selectedValue]
        } else {
          model.value = selectedValue
        }
      } else {
        if (multiple) {
          const { answerConfig: { optionExInd, optionExType, optionExItems, answerLimitInd } } = config
          const otherList = config.optionList.filter(
            item => item.type === 'special'
          )
          let otherSelectedIndex = -1
          if (otherList.length) {
            value.some((item, index) => {
              if (otherList.find(o => o.id === item)) {
                otherSelectedIndex = index
                return true
              }
              return false
            })
          }
          const valueIndex = this.selectedIndex(option)
          const optionId = option.id
          if (otherSelectedIndex !== -1) {
            value.splice(otherSelectedIndex, 1)
          } else if (optionExInd === '1') {
            const util = this.$util
            if (optionExType === '01') {
              if (util.isContainsArr(optionExItems, value) || optionExItems.includes(optionId)) {
                value.splice(0, value.length, optionId)
                return
              }
            } else if (optionExType === '02') {
              if (util.isContainsArr(optionExItems, value) && optionExItems.includes(optionId) && !value.includes(optionId)) {
                const mutualId = optionExItems.find(id => id !== optionId)
                const mutualIndex = value.findIndex(id => id === mutualId)
                value.splice(mutualIndex, 1, optionId)
                return
              }
            }
          }
          valueIndex === -1
            ? value.push(selectedValue)
            : value.splice(valueIndex, 1)

          // 勾选”不清楚/不知道“需和其它选项产生互斥关系
          if (type === 'unknown') {
            if (valueIndex === -1) {
              value.splice(0, value.length)
              value.push(option.id)
            }
          } else {
            // 选其它选项时，如“不清楚/不知道“选项已勾选，则取消勾选
            let unknownIndex = -1
            value.forEach((item, itemIndex) => {
              config.optionList.forEach(optionItem => {
                if (optionItem.type === 'unknown' && item === optionItem.id) {
                  unknownIndex = itemIndex
                }
              })
            })
            if (unknownIndex > -1) {
              value.splice(unknownIndex, 1)
            }
          }
        } else {
          // TODO: 矩阵滑块题-利克特量表校验
          if (this.config.elementType === 'RateGroupBox') {
            this.$emit('selIndexChange', this.crtDescIndex)
          }
          model.value = selectedValue
        }
      }
      // console.log(model.value)
    },
    selectedIndex (option) {
      const { multiple } = this
      const { selectedValue, value } = this.getValue(option)
      if (multiple) {
        return value.findIndex(id => id === selectedValue)
      }
    },
    isSelected (option) {
      const { multiple, model } = this
      const { selectedValue, value } = this.getValue(option)
      if (multiple) {
        return value.includes(selectedValue)
      }
      return model.value === selectedValue
    },
    getValue (option) {
      const { model, optionValueKey } = this
      const selectedValue = option[optionValueKey]
      const value = model.value
      return {
        selectedValue,
        value
      }
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    },
    getSurveyInfoLang: function () {
      return this.surveyInfoLang
    },
    getVotingResult: function () {
      const data  = {
        surveyId: this.model.belongId,
        quId: this.model.id,
      }

      //  设置每个选项的比例
      getVotingResult(data).then(res =>{
        let sumVotes = res.reduce((prev,curr)=>{
          return prev + curr.num
        }, 0)

        if (this.config.value && !sumVotes) {
          sumVotes = 1
        }
        this.config.optionList.forEach(option=>{
          let targetOption = res.find(item => item.quItemId === option.id)
          if (targetOption) {
            this.$set(option, 'votes', targetOption.num)
            this.$set(option, 'sumVotes', sumVotes)
            if (option.sumVotes) {
              this.$set(option, 'percentage', parseInt(option.votes/option.sumVotes * 100))
              this.$set(option, 'rate', Number(option.votes/option.sumVotes * 100).toFixed(2))
            } else {
              this.$set(option, 'percentage', 0)
              this.$set(option, 'rate', 0.00)
            }
          } else {
            if (this.config.value === option.id) {
              this.$set(option, 'votes', 1)
              this.$set(option, 'sumVotes', sumVotes)
              this.$set(option, 'percentage', parseInt(option.votes/option.sumVotes * 100))
              this.$set(option, 'rate', Number(option.votes/option.sumVotes * 100).toFixed(2))
            } else {
              this.$set(option, 'votes', 0)
              this.$set(option, 'sumVotes', sumVotes)
              this.$set(option, 'percentage', 0)
              this.$set(option, 'rate', 0.00)
            }
          }
        })
      })
    }
  },
  created () {
  },
  mounted () {
    this.config.tipsVote = this.cvtLang('tipsVote', this.config.tipsVote)
    // 投票题时请求该题的投票结果
    if (this.config.mediaQuType === 'vote') {
      if (window._env_ === 'android') {
        this.config.answerConfig.isShowVotingScore = '0'
      } else {
        this.getVotingResult()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .top {
    display: flex;
  }
  .group {
    margin-bottom: 20px;
    .group-media {
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      img {
        width: 100%;;
      }
    }
    .group-title {
      font-size: 32px!important;
      line-height: 32px!important;
      margin: 20px 0 30px;
    }
    @media screen and (min-width: 960px)  {
      .group-title {
        font-size: 18px!important;
        line-height: 18px!important;
        margin: 20px 0 20px;
      }
    }
  }
  .answer-pc {
    .group {
      .group-media {
        .av-wrap {
          width: 100% !important;
        }
        >>> .video-js {
          width: 100% !important;
          height: 250px !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/answer/AnswerOptionList.vue